import React from 'react'
import { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const form = useRef();

  const [ reCaptcha, onReCaptcha ] = useState(false);
  const [ formSent, onFormSent ] = useState(false);
  const [ verifyMessage, onVerifyMessage ] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    if (reCaptcha !== true) 
    {
      onVerifyMessage(true);
      return;
    }

    emailjs.sendForm('service_7ybd4je', 'template_feodw2k', form.current, 'RaaMirOr_-mXcK84z')
    onFormSent(true);
  };
  
  const { ref: contactRef, inView: myElementIsVisible } = useInView();

  let titleStyle = myElementIsVisible ? 'fade-in' : 'fade-out'

  let card = 'contact__option '
  card += myElementIsVisible ? 'show-from-left' : 'hide-from-left'

  const onChangeCaptcha = () => {
    onReCaptcha(!reCaptcha);
    onVerifyMessage(false)
  }

  const formDisplay = () => {
    if (formSent === false)
    {
      return (
        <form ref={form} onSubmit={sendEmail} className={titleStyle}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required ></textarea>
          { verifyMessage ? <p className='text-color-red'>Verify the CAPTCHA!</p> : ''}
          <ReCAPTCHA
            sitekey="6LchehwlAAAAAHcl3DoTE1JEWvzXLFyIxSezBNhH"
            onChange={onChangeCaptcha}
          />
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      )
    }
    else
    {
      return (
        <p>MESSAGE SENT!</p>
      )
    }
  }

  return (
    <section id='contact' ref={contactRef}>
      <h5 className={titleStyle}>Get In Touch</h5>
      <h2 className={titleStyle}>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className={card}>
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>myramkenacc@gmail.com</h5>
            <a href="mailto:myramkenacc@gmail.com" target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className={card}>
            <RiMessengerLine className='contact__option-icon'/>
            <h4>Messenger</h4>
            <h5>Ram Ken</h5>
            <a href="https://m.me/ehlwas" target="_blank" rel="noreferrer">Send a message</a>
          </article>
          <article className={card}>
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>+971 582 81 3404</h5>
            <a href="https://wa.me/971582813404" target="_blank" rel="noreferrer">Send a message</a>
          </article>
        </div>
        {/* /* END OF CONTACT OPTIONS /* */}
        { formDisplay() }
      </div>
    </section>
  )
}

export default Contact
